module.exports = __webpack_public_path__ + "img/img21.17298728.svg";